"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.courseWrapperTabWhitelistRegex = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _CourseWrapperMediator = _interopRequireDefault(require("./CourseWrapperMediator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var courseWrapperTabWhitelistRegex = exports.courseWrapperTabWhitelistRegex = /\/(courseDescription|course|registration|finalTest|certificate|courseEval|resources)$/;
var MediatorRoot = function MediatorRoot(ownProps) {
  var _ownProps$match, _ownProps$match$param, _ownProps$match2, _ownProps$match2$para;
  // second param might be either pawn shortHash or course wrapper tab, so handle both cases
  var matchPath = ownProps.match.path;
  if (matchPath.includes('/:shortHash') && (!((_ownProps$match = ownProps.match) !== null && _ownProps$match !== void 0 && (_ownProps$match$param = _ownProps$match.params) !== null && _ownProps$match$param !== void 0 && _ownProps$match$param.shortHash) || /(courseDescription|course|registration|finalTest|certificate|courseEval)/.test(((_ownProps$match2 = ownProps.match) === null || _ownProps$match2 === void 0 ? void 0 : (_ownProps$match2$para = _ownProps$match2.params) === null || _ownProps$match2$para === void 0 ? void 0 : _ownProps$match2$para.shortHash) || ''))) {
    matchPath = matchPath.slice(0, matchPath.indexOf('/:shortHash'));
  }
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: matchPath + '/:courseWrapperTab?',
    render: function render(props) {
      var basePath = ownProps.match.url.replace(courseWrapperTabWhitelistRegex, '');
      return /*#__PURE__*/_react["default"].createElement(_CourseWrapperMediator["default"], _extends({}, ownProps, props, {
        basePath: basePath
      }));
    }
  });
};
var _default = exports["default"] = (0, _reactRouterDom.withRouter)(MediatorRoot);